import { ApolloQueryResult } from '@apollo/client'
import { GuildUpdate, Project } from '@/organisms/ProjectJourney/types'
import {
  FetchProjectForProjectJourneyQuery,
  FetchProjectPhasesForProjectJourneyQuery,
} from '@/types/codegen-federation'
import { isDefined } from '@/utils/types'
import { getWebClient } from '../ApolloClient'
import { GET_PROJECT_PHASES, GET_PROJECT } from './queries'

export const getProjectJourneyData = async (
  projectSlug: string,
): Promise<{
  guildUpdates: GuildUpdate[]
  project: Project | undefined
}> => {
  const client = getWebClient()
  const projectPhasesResult = await client.query<FetchProjectPhasesForProjectJourneyQuery>({
    query: GET_PROJECT_PHASES,
    variables: { projectSlug },
    errorPolicy: 'all',
  })

  const projectUuid = projectPhasesResult.data.project?.projectUuid
  let projectResult: ApolloQueryResult<FetchProjectForProjectJourneyQuery> | undefined = undefined
  if (projectUuid) {
    projectResult = await client.query<FetchProjectForProjectJourneyQuery>({
      query: GET_PROJECT,
      variables: { projectUuid },
      errorPolicy: 'all',
    })
  }

  return {
    guildUpdates: projectResult?.data.guildUpdates?.filter(isDefined) ?? [],
    project: projectPhasesResult.data.project ?? undefined,
  }
}
